import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AjaxService } from "src/app/service/ajax.service";
import { AuthService } from "src/app/service/auth.service";
import { UtilService } from "src/app/service/util.service";
import { API } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';

interface ResultadoPrograma {
  nome: string;
  crianca: string;
  responsaveL_NOME: string;
  idade: number;
  sexo: string;
  atividadeCurrence?: {
    etapa: string;
    modulo: string;
    atividade: string;
  };
}

interface Triagem {
  titulo: string;
  // outros campos da triagem se necessário
}

@Component({
  selector: "app-resultados-programa",
  templateUrl: "./resultados-programa.component.html",
  styleUrls: ["./resultados-programa.component.scss"],
})
export class ResultadosProgramaComponent implements OnInit {
  resultados: ResultadoPrograma[] = [];
  filteredResults: ResultadoPrograma[] = [];
  searchText: string = '';
  triagens: Triagem[] = [];
  selectedTriagem: string = '';

  constructor(
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: AuthService,
    private http: HttpClient
  ) {

  }

  ngOnInit(): void {
    this.buscarResultados();
    this.carregarTriagens();
  }

  onSearch(): void {
    if (!this.searchText.trim()) {
      this.filteredResults = this.resultados;
      return;
    }

    const searchTerm = this.searchText.toLowerCase().trim();
    this.filteredResults = this.resultados.filter(resultado => 
      resultado.responsaveL_NOME?.toLowerCase().includes(searchTerm) ||
      resultado.nome?.toLowerCase().includes(searchTerm) ||
      resultado.atividadeCurrence?.etapa?.toLowerCase().includes(searchTerm) ||
      resultado.atividadeCurrence?.modulo?.toLowerCase().includes(searchTerm) ||
      resultado.atividadeCurrence?.atividade?.toLowerCase().includes(searchTerm)
    );
  }

  buscarResultados() {
    this.util.showLoading();
   let url = API + "AtividadePrograma/AtividadePrograma/ConsultarCriancasTriagem?ID_TRIAGEM=" + this.selectedTriagem;
    return this.ajax.get(url).subscribe(
      (response) => {
        this.resultados = response.data;
        this.filteredResults = this.resultados;
        this.util.closeLoading();
      },
      (err) => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao carregar resultados");
      }
    );
  }

  carregarTriagens(): void {
    this.util.showLoading();
    let url = API + "Triagem/Triagem";
    return this.ajax.get(url).subscribe(
      (response) => {
        this.triagens = response.data;
        if (this.triagens.length > 0) {
          this.selectedTriagem = this.triagens[0].titulo;
        }
        this.util.closeLoading();
      },
      (err) => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao carregar triagens");
      }
    );
  }

  exportarRespostas(){
    this.util.showLoading();
    var url = API + 'RespostaFormulario/RespostaFormulario/exportarResultadoProgramaTriagem/'+this.selectedTriagem; 
    window.open(url); 
    this.util.closeLoading();
   
  }

  onTriagemChange(event: any): void {
    debugger
    this.selectedTriagem = event.target.value;
    console.log('Triagem selecionada:', this.selectedTriagem);

    this.buscarResultados();
  }
}
